import BotBubble from './BotBubble';

import { useGetAIChatbotAnswer } from '@/hooks/V3/useGetAIChatbotAnswer';
import { useChatbotContext } from '../../_context/ChatbotContext';
import Button from '@/components/atoms/Button';
import { CHATBOT_INITIAL_MESSAGE, SESSION_RESET_ALERT } from '../../_constants/_const';

const ResetSessionButton = ({ idx }: { idx: number }) => {
  const { setIsThinking, setMessages, messages } = useChatbotContext();
  const { getAiChatBotAnswer } = useGetAIChatbotAnswer();
  const isLast = idx === messages.length - 1;

  const handleResetSession = async () => {
    // localStorage.removeItem(TARGET_LOCAL_KEY);

    setMessages([...messages, SESSION_RESET_ALERT, CHATBOT_INITIAL_MESSAGE]);

    setIsThinking(true);
    getAiChatBotAnswer({ messageText: '', skipMessageSave: true }).then(() => {
      setIsThinking(false);
    });
  };

  return (
    <div className="flex flex-col gap-1 pb-[8px]">
      <BotBubble
        type="headerBubble"
        text="시스템에 문제가 발생했어요. 대화를 처음부터 다시 시작해 주세요."
        isDashboard={true}
      />
      {isLast && (
        <div>
          <Button variant="outline" onClick={handleResetSession}>
            새로운 대화
          </Button>
        </div>
      )}
    </div>
  );
};

export default ResetSessionButton;
